import React, { FC, memo } from 'react'
import { SeoItemsTransport } from '../../../transports/home-page-transport'
import {
    ColumnBox,
    RegionItem,
    RegionListItem,
    ImageWrapper,
    Content,
    Title,
    SubTitle,
    IconContainer,
    ArrowRightIcon,
    ContentContainer,
} from './styles'

interface RegionColumnProps {
    regions: SeoItemsTransport[]
}

const RegionColumn: FC<RegionColumnProps> = ({ regions }) => (
    <ColumnBox>
        {regions.map(region => (
            <RegionListItem key={region.title}>
                <RegionItem href={region.link} noCrawl={region.noCrawl}>
                    {!!region.imagePath && (
                        <ImageWrapper>
                            <img src={region.imagePath} alt={region.title} loading="lazy" />
                        </ImageWrapper>
                    )}
                    <ContentContainer>
                        <Content>
                            <Title>{region.title}</Title>
                            {!!region.subTitle && <SubTitle>{region.subTitle}</SubTitle>}
                        </Content>
                        <IconContainer>
                            <ArrowRightIcon />
                        </IconContainer>
                    </ContentContainer>
                </RegionItem>
            </RegionListItem>
        ))}
    </ColumnBox>
)

export default memo(RegionColumn)
